import { action, observable } from 'mobx';

class Cache {
  @observable stores = new Map();

  @action.bound
  get(key) {
    return this.stores.get(key);
  }
}
export default Cache;
